import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Stack)`
  background: ${(p) => p.theme.palette.primary[50]};
  margin-top: ${(p) => p.theme.spacing(3)};
  padding: 0 ${(p) => p.theme.spacing(10.625)};
  text-align: center;
  background-image: url('/assets/images/Faq-background.svg');
  background-repeat: no-repeat;
  background-position: center top;
  background-size: auto;
`;
